export const LogEventTypes = {
  ENROLLMENT: 'ENROLLMENT',
  ACTION_EXECUTION: 'ACTION_EXECUTION',
  PRE_ENROLLMENT: 'PRE_ENROLLMENT',
  UNENROLLMENT: 'UNENROLLMENT'
};
export const EnrollmentHistoryLogEventTypes = [LogEventTypes.ENROLLMENT, LogEventTypes.PRE_ENROLLMENT];
export const NotificationTypes = {
  ALL: 'ALL',
  SUCCESS: 'SUCCESS',
  INFORMATION: 'INFORMATION',
  ERROR: 'ERROR'
};
// AutomationPlatform types
// See https://git.hubteam.com/HubSpot/AutomationPlatform/blob/master/AutomationPlatformBase/src/main/protobuf/automationplatform.proto
export const EnrollmentStates = {
  ENROLLED: 'ENROLLED',
  UNENROLLED: 'UNENROLLED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};
export const EnrollTypes = {
  MANUAL_ENROLL: 'MANUAL_ENROLL',
  DYNAMIC_ENROLL: 'DYNAMIC_ENROLL',
  BULK_ENROLL: 'BULK_ENROLL',
  RE_ENROLL: 'RE_ENROLL',
  EXTERNAL_TRIGGER_ENROLL: 'EXTERNAL_TRIGGER_ENROLL',
  ACTION_EXECUTION_ENROLL: 'ACTION_EXECUTION_ENROLL'
};
export const UnenrollTypes = {
  SUPPRESSION_UNENROLL: 'SUPPRESSION_UNENROLL',
  MANUAL_UNENROLL: 'MANUAL_UNENROLL',
  SUPPRESSION_REMOVE_UNENROLL: 'SUPPRESSION_REMOVE_UNENROLL',
  MERGE_UNENROLL: 'MERGE_UNENROLL',
  REMOVE_FROM_WORKFLOWS_SETTING_UNENROLL: 'REMOVE_FROM_WORKFLOWS_SETTING_UNENROLL'
  // FLOW_DISABLED: 'FLOW_DISABLED', // deprecated
  // EXTERNAL_TRIGGER_UNENROLL: 'EXTERNAL_TRIGGER_UNENROLL', // should never occur for platform flows
};
export const ClassicUnenrollTypes = {
  UNENROLLED_BY_WORKFLOW: 'UNENROLLED_BY_WORKFLOW',
  PRE_ENROLLMENT_GOAL_MET: 'PRE_ENROLLMENT_GOAL_MET',
  FAILED_ENROLLMENT_ANCHOR_PROPERTY_MISSING_ON_CONTACT: 'FAILED_ENROLLMENT_ANCHOR_PROPERTY_MISSING_ON_CONTACT',
  FAILED_ENROLLMENT_ANCHOR_PROPERTY_MISSING_ON_WORKFLOW: 'FAILED_ENROLLMENT_ANCHOR_PROPERTY_MISSING_ON_WORKFLOW'
};
export const ExecutionStates = {
  SUCCESS: 'SUCCESS',
  PARTIAL_SUCCESS: 'PARTIAL_SUCCESS',
  SKIPPED: 'SKIPPED',
  FAIL_RETRY: 'FAIL_RETRY',
  FAIL_IRREPARABLE: 'FAIL_IRREPARABLE',
  DEFERRED: 'DEFERRED',
  FAIL_CONTINUE: 'FAIL_CONTINUE',
  FAIL_RESCHEDULE: 'FAIL_RESCHEDULE',
  ASYNC: 'ASYNC'
};
// Automation types
// See https://git.hubteam.com/HubSpot/Automation/blob/master/AutomationBase/src/main/protobuf/automation.proto
export const TriggerObjectTypes = {
  FORM: 'FORM',
  DYNAMIC_LIST: 'DYNAMIC_LIST',
  PAGE: 'PAGE',
  FOLLOWUP_EMAIL_ID: 'FOLLOWUP_EMAIL_ID',
  WORKFLOW_ID: 'WORKFLOW_ID',
  STATIC_LIST_BULK_ENROLLMENT: 'STATIC_LIST_BULK_ENROLLMENT',
  SINGLE_EMAIL: 'SINGLE_EMAIL',
  FOLLOWUP_EMAIL_CAMPAIGN_ID: 'FOLLOWUP_EMAIL_CAMPAIGN_ID',
  SINGLE_VID: 'SINGLE_VID',
  EMAIL_OPT: 'EMAIL_OPT',
  PAGE_VIEW: 'PAGE_VIEW',
  EVENT: 'EVENT',
  CONTACT_PROPERTY_NAME: 'CONTACT_PROPERTY_NAME',
  CONTACT_PROPERTY_VALUE: 'CONTACT_PROPERTY_VALUE',
  SEGMENT: 'SEGMENT',
  INTEGRATIONS_TIMELINE_EVENT: 'INTEGRATIONS_TIMELINE_EVENT',
  ENROLL_EXISTING: 'ENROLL_EXISTING',
  ACTIVATION_BULK_ENROLLMENT: 'ACTIVATION_BULK_ENROLLMENT',
  ENROLLMENT_CRITERIA_MODIFIED_BULK_ENROLLMENT: 'ENROLLMENT_CRITERIA_MODIFIED_BULK_ENROLLMENT',
  CHATFLOW_ID: 'CHATFLOW_ID'
};
// AutomationPlatform types
// See https://git.hubteam.com/HubSpot/AutomationPlatform/blob/master/AutomationPlatformBase/src/main/protobuf/automationplatform.proto
export const FilterEventTypes = {
  OBJECT_DELETED_FILTER: 'OBJECT_DELETED_FILTER',
  OBJECT_DOES_NOT_EXIST_FILTER: 'OBJECT_DOES_NOT_EXIST_FILTER',
  SUPPRESSION_FILTER: 'SUPPRESSION_FILTER',
  RE_ENROLLMENT_NOT_ENABLED_FILTER: 'RE_ENROLLMENT_NOT_ENABLED_FILTER',
  MERGE_FILTER: 'MERGE_FILTER',
  LISTENING_FILTER: 'LISTENING_FILTER',
  GOAL_MET_FILTER: 'GOAL_MET_FILTER',
  ALREADY_ENROLLED_FILTER: 'ALREADY_ENROLLED_FILTER',
  ANCHOR_PROPERTY_MISSING_DATE_FILTER: 'ANCHOR_PROPERTY_MISSING_DATE_FILTER',
  MISSING_ANCHOR_PROPERTY_FILTER: 'MISSING_ANCHOR_PROPERTY_FILTER'
};